"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogger = exports.LoggingService = void 0;
const messaging_common_1 = require("@guided-methods/messaging-common");
const axios_1 = __importDefault(require("axios"));
function parseOutgoingPayloadFromLogMessage(message) {
    if (!message || message.length <= 0) {
        return undefined;
    }
    const marker = 'data:';
    const markerIndex = message.indexOf(marker);
    if (markerIndex < 0) {
        return undefined;
    }
    const jsonText = message.slice(markerIndex + marker.length).trim();
    if (!jsonText.startsWith('{') || !jsonText.endsWith('}')) {
        return undefined;
    }
    let parsed;
    try {
        parsed = JSON.parse(jsonText);
    }
    catch {
        return undefined;
    }
    if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
        return undefined;
    }
    if (parsed?.type !== messaging_common_1.GuideMessageType.Data
        && parsed?.type !== messaging_common_1.GuideMessageType.EndChannel
        && parsed?.type !== messaging_common_1.GuideMessageType.KeepAlive) {
        return undefined;
    }
    if (parsed.data !== undefined) {
        if (parsed.data === null
            || typeof parsed.data !== 'object'
            || Object.keys(parsed.data).length <= 0
            || Array.isArray(parsed.data)) {
            return undefined;
        }
        if (typeof parsed.data?.type !== 'string') {
            return undefined;
        }
    }
    return parsed;
}
function isEndChannelMessage(payload) {
    return payload.type === messaging_common_1.GuideMessageType.EndChannel;
}
function isGuideCompletedDataMessage(payload) {
    return payload.type === messaging_common_1.GuideMessageType.Data && payload.data?.type === 'guide-completed';
}
function isGuideResultDataMessage(payload) {
    return payload.type === messaging_common_1.GuideMessageType.Data && payload.data?.type === 'guide-result';
}
class LoggingService {
    constructor(tokenService, url, batchSize, batchInterval) {
        this.latestPost = Date.now();
        this.logs = [];
        this.log = (event) => {
            let messagesToSend = undefined;
            const parsedPayload = parseOutgoingPayloadFromLogMessage(event?.message);
            const forcePost = !!parsedPayload && (isGuideResultDataMessage(parsedPayload)
                || isGuideCompletedDataMessage(parsedPayload)
                || isEndChannelMessage(parsedPayload));
            if (event?.level === messaging_common_1.LogLevel.ERROR || event.level === messaging_common_1.LogLevel.WARNING) {
                messagesToSend = [event];
            }
            else {
                this.logs.push(event);
                if (forcePost || this.logs.length >= this.batchSize || this.latestPost + this.batchInterval < Date.now()) {
                    messagesToSend = this.logs;
                    this.logs = [];
                    this.latestPost = Date.now();
                }
            }
            if (messagesToSend) {
                let objJsons = JSON.stringify(messagesToSend);
                this.tokenService.getToken().then(token => {
                    const config = {
                        headers: { Authorization: `Bearer ${token}`, 'content-type': 'application/json' }
                    };
                    axios_1.default.post(this.url, objJsons, config).then().catch(error => console.error('Failed to post log messages: ', error.message));
                });
            }
        };
        this.tokenService = tokenService;
        this.url = url;
        this.batchSize = batchSize;
        this.batchInterval = batchInterval;
    }
}
exports.LoggingService = LoggingService;
const createLogger = (tokenService, appName, appVersion, runnerId, url, environment, batchSize = 8, batchInterval = 5000) => {
    tokenService.getToken().then(token => {
    });
    const loggingService = new LoggingService(tokenService, url, batchSize, batchInterval);
    return async (message) => {
        const user = await tokenService.userManager.getUser();
        const userId = tokenService?.userManager ? user?.profile.sub : "";
        const event = Object.keys(message).reduce((result, field) => field in result ? result : { ...result, [makeFieldName(field)]: message[field] }, {
            'app': appName,
            'version': appVersion,
            'team': message.team !== undefined && message.team !== null && message.team !== '' ? message.team : 'tiger',
            'env': environment,
            'level': message.level,
            'correlationId': message.correlationId,
            'message': message.message,
            'timestamp': message.timestamp,
            'user': userId,
            'userAgent': navigator.userAgent,
            'exception': message.exception,
            'GuidedMethods.chunk': message.chunkId ?? 'host',
            'productId': message.productId,
            'productIdType': message.productIdType,
            'jobId': message.jobId
        });
        return loggingService.log(event);
    };
};
exports.createLogger = createLogger;
const makeFieldName = (field) => field.startsWith('GuidedMethods.') ? field : `GuidedMethods.${field}`;
